export enum AdditionalStatus {
  Included,
  Available,
  NotIncluded,
  IncludedWithValue
}

// export enum QuestionSpecification {
//   None,
//   Car_CoverType,
//   Car_OptionalExtras,
//   Personal_OpenCover,
//   Personal_MoreInsurant,
//   Personal_FirstName,
//   Personal_LastName,
//   Insurance_StartDate,
//   Car_VehiclePrice,
//   Insurance_Voluntary
// }


export enum QuestionType {
  Text,
  Checkbox,
  Select,
  RadioButton,
  MultiSelect,
  DatePicker,
  Digits,
  YesNoRadioButton,
  PhoneNumber
}

export enum TypeSpecification {
  None,
  Car,
  Home
}

export enum EntityProperty {
  None,
  Car_PowerRpm,
  Car_TorqueRPM,
  Car_Classification,
  Car_Year,
  Car_Brand,
  Car_Model,
  Car_Trim,
  Car_DriveTrain,
  Car_BodyType,
  Car_NoOfDoors,
  Car_NoOfSeats,
  Car_MakeCountry
}

export enum PaymentType {
  Cash,
  Linx,
  Card,
  BankTransfer = 3
}

export enum ZohoAction {
  PersonalInfoCompleate,
  QuotesCompleate,
  PurchaseNow
}

export enum QuestionIdentifier {
  BirthDate = 8,
  DriverUnder25YearsOld = 20
}

export enum QuestionOptionIdentifier {
  DriverUnder25YearsOldYes = 7,
  DriverUnder25YearsOldNo = 8,
}
